export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  JPY: "¥",
  PLN: "zł",
  VND: "₫",
  CHF: "Fr.",
  NZD: "$",
  ARS: "$",
};
